import { render, staticRenderFns } from "./ChallengesForm.vue?vue&type=template&id=ced0364a&scoped=true&"
import script from "./ChallengesForm.vue?vue&type=script&lang=ts&"
export * from "./ChallengesForm.vue?vue&type=script&lang=ts&"
import style0 from "./ChallengesForm.vue?vue&type=style&index=0&id=ced0364a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced0364a",
  null
  
)

export default component.exports